module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/es-to-primitive/helpers/isPrimitive.js
// module id = 639
// module chunks = 168707334958949